/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Dashboard
 *| (C) Copyright IBM Corp. 2018, 2020
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */
define([
	'../../../visualizations/recommender/VisRecommenderBindingFallback'
], function (VisRecommenderBindingFallback) {
	'use strict';
	return class VisRecommenderDelegator {
		constructor(options) {
			this.logger = options.logger;
			this.visDefinitions =  options.visDefinitions;
		}

		destroy() {
			this.logger = null;
		}

		recommendBindingsForNewColumns(visualization, columnIds) {
			const bindingRecommender = new VisRecommenderBindingFallback(visualization);
			const recommendation = {
				slots:{},
				unbound: columnIds,
				visId: visualization.getDefinition().getId()
			};

			visualization.getSlots().getMappingInfoList().forEach(mapping => {
				let cols = recommendation.slots[mapping.slot.getId()];
				if (!cols){
					cols = [];
					recommendation.slots[mapping.slot.getId()] = cols;
				}
				cols.push(mapping.dataItem.getColumnId());
			});


			bindingRecommender.assignUnboundColumns(recommendation, visualization.getDefinition().getSlotList());
			return Promise.resolve(recommendation);
		}

		_getValidSlotList(newDefinition) {
			return newDefinition.getSlotList().filter(slotDef=>!slotDef.isHidden());
		}

		recommendBindingsForSelectedViz(visualization, visId) {
			const newDefinition = this.visDefinitions.getById(visId);
			const bindingRecommender = new VisRecommenderBindingFallback(visualization);
			const recommendation = {
				slots:{},
				unbound: visualization.getSlots().getDataItemList().map(dataItem => dataItem.getColumnId()),
				visId: newDefinition.getId()
			};
			bindingRecommender.assignUnboundColumns(recommendation, this._getValidSlotList(newDefinition));
			return Promise.resolve(recommendation);
		}

		recommendBestAlternateVisualization(visualization) {
			const mappings =  visualization.getSlots().getDataItemList().map(dataItem => dataItem.getColumnId());
			return this.recommendAlternateVisualizations(mappings).then(arr => arr[0]);
		}

		recommendAlternateVisualizations(columnIds) {
			const gridDefinition = this.visDefinitions.getByType('List');
			const recommendation = {
				slots:{},
				visId: gridDefinition.getId()
			};
			const mappings = columnIds;
			recommendation.slots[gridDefinition.getSlotList()[0].getId()] = mappings;
			return Promise.resolve([recommendation]);
		}

		recommendRelatedVisualizations() {
			return Promise.resolve([]);
		}

		recommendCompareVisualizations() {
			return Promise.resolve([]);
		}

		recommendVisualizations() {
			return Promise.resolve([]);
		}
	};
});
